
export const getTemplate = async ({template_name}: {template_name: string}) => {
    const templates = import.meta.glob("@client/templates/*.tsx");

    const templatePath = `/client/templates/${template_name}.tsx`;
    const TemplateModule = await templates[templatePath]() as {Template: React.ComponentType<any>};
    return TemplateModule.Template;
}
